import React, { useState, useEffect } from "react";
import useScreenHeight from '../../../../components/useScreenHeight';
import { useNavigate } from 'react-router-dom';
import DefaultsSidebar from './DefaultsSidebar2';
import actionTypes from '../../../../actions/ActionTypes';
import TemplateStore from '../../../../stores/TemplateStore';
import DefaultStore from '../../../../stores/DefaultsStore';
import {
    GetFormTypesICanEditTemplates,
} from '../../../../actions/TemplateActions';
import {
    GetDefaultDetails,
} from '../../../../actions/DefaultActions';

const DefaultManager = () => {
    const navigate = useNavigate();
    const [defaultList, setDefaultList] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [filteredDefaultList, setFilteredDefaultList] = useState([]);

    const [formTypeFilter, setFormTypeFilter] = useState(0);
    const [maxHeight, setMaxHeight] = useState(window.innerHeight - 200);
    const screenHeight = useScreenHeight();

useEffect(() => {
    TemplateStore.addChangeListener(onReceiveTemplateChange);
    DefaultStore.addChangeListener(onReceiveDefaultChange);
    GetDefaultDetails();
    GetFormTypesICanEditTemplates();
    document.title = 'TrinDocs - Defaults'

    let ftFilter = sessionStorage.getItem("TEFormTypeFilter");
    if(ftFilter !== undefined && ftFilter !== null)
    {
    // let intFt = parseInt(ftFilter, 10);
    //     setFormTypeFilter(intFt);
    // } else {
    //     setFormTypeFilter(0);
    //
    }
    return () => {
        TemplateStore.removeChangeListener(onReceiveTemplateChange);
        DefaultStore.removeChangeListener(onReceiveDefaultChange);
    }
}, []);

useEffect(() => {
    setMaxHeight(screenHeight-110);
}, [screenHeight]);

useEffect(() => {
    let ftgs = defaultList;
    let ftId = formTypeFilter;
    let filter = [];
    ftgs.forEach((fg) => {
        let filterGroup = { formTypeId: fg.formTypeId, formTypeName: fg.formTypeName, defaults: [] };
        if(ftId === 0 || ftId === fg.formTypeId){

            fg.defaults.forEach((def) => {
                if(def.defaultName.toLowerCase().includes(searchText.toLowerCase()) || searchText === '')
                {
                    filterGroup.defaults.push(def);
                }
            });
        }
        if(filterGroup.defaults.length > 0)
        {
            filter.push(filterGroup);
        }
    });

    filter = filter.sort((a,b) => { return a.formTypeName < b.formTypeName ? -1 : 1 });
    setFilteredDefaultList(filter);
}, [searchText, defaultList, formTypeFilter]);



  const onReceiveTemplateChange = () => {
    let lastChange = TemplateStore.getLastChange();
    if (lastChange === actionTypes.TemplateGetDetails) {
      let templates = TemplateStore.getTemplateDetails();
      setDefaultList(templates);
      setSearchText('');

    }
  }

  const onReceiveDefaultChange = () => {
    let lastChange = DefaultStore.getLastAction();
    if(lastChange === actionTypes.DefaultGetDetails)
    {
        let defaults = DefaultStore.getDefaultDetails();
        setDefaultList(defaults);
        setFilteredDefaultList(defaults);
        setSearchText('');
    }
  }

  const onClickFromType = (group) => {
    sessionStorage.setItem("TEFormTypeFilter", group);
    setFormTypeFilter(group);
  }

  const onSearchChange = (e) => {
    let search = e.target.value;
    setSearchText(search);

  }

  const onDefaultClick = (e, id) => {
    console.log(id);
    if(e.ctrlKey) {
      // new tab
      window.open(`/Admin/Defaults/${id}`);
    } else {
        navigate(`/Admin/Defaults/${id}`)
    }
  }

    return (
      <div className='sidebarLayout d-flex flex-row flex-fill'>
        <div className='sidebar-container2'>
          <DefaultsSidebar setFTFilter={onClickFromType}  />
        </div>
        <div className='flex-fill'>
            <div
                className='card'
                style={{
                marginTop: '20px',
                marginLeft: '30px',
                marginRight: '30px',
                maxHeight: `${maxHeight}px`,
                }}
            >
                <div className='card-header'>
                    <table>
                        <tbody>
                            <tr>
                                <td><h4>Defaults</h4></td>
                                <td className='row g-3' style={{paddingLeft: '20px'}}>
                                <div className='input-group rounded' >
          <input
            type='search'
            value={searchText}
            className='form-control'
            placeholder='Search'
            aria-label='Search'
            onChange={onSearchChange}
            aria-describedby='search-addon'
          />
          <span className='input-group-text border-0' id='search-addon'>
            <i className='fa-solid fa-search' />
          </span>
        </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div
                className='card-body'
                style={{
                    overflowY: 'auto',
                    overflow: 'scroll',
                    maxHeight: '20%',
                }}
                >
            <table className='table'>
                <thead className='thead-dark'>
                    <tr>
                    <th style={{width: '60px'}}></th>
                    <th style={{width: '200px'}}>Default Name</th>
                    <th>Value Count</th>
                    <th></th>
                    </tr>
                </thead>
                <tbody >
                    {filteredDefaultList.map((ftg) =>
                        <React.Fragment key={ftg.formTypeId}>
                            <tr key={ftg.formTypeId}>
                                <td colSpan='9' style={{fontSize: '16pt', fontWeight: 'bold'}}><span style={{color: '#40A430'}} ><i className='fa-solid fa-file-invoice' /></span>{' '}{ftg.formTypeName}</td>
                            </tr>
                            {ftg.defaults.map((temp) =>
                            <tr key={temp.defaultId}>
                            <td><button className='btn btn-sm btn-info' onClick={(e) => onDefaultClick(e, temp.defaultsDBId)}><i className='fa-solid fa-pen-to-square' /></button></td>
                            <td>{temp.defaultName}</td>
                            <td>{temp.valueCount}</td>
                            <td></td>
                        </tr>
                            )}
                        </React.Fragment>
                    )}
                </tbody>
            </table>
            </div>
          </div>
        </div>
      </div>
    );

}

export default DefaultManager;
